/* Cozey PDP behaviour for sections/cozey-product.liquid. Static asset; config read from the DOM. */
(function(){
  function initPDP(root){
    if(!root || root.dataset.czInit) return;
    root.dataset.czInit = "1";
    var variants = [], prices = {};
    var vEl = root.querySelector('[data-cz-variants]');
    var pEl = root.querySelector('[data-cz-prices]');
    try { if(vEl) variants = JSON.parse(vEl.textContent); } catch(e){}
    try { if(pEl) prices = JSON.parse(pEl.textContent); } catch(e){}
    var form = root.querySelector('.cz-pdp__form');
    var idInput = root.querySelector('[data-cz-variant-id]');
    var atc = root.querySelector('[data-cz-atc]');
    var atcText = root.querySelector('[data-cz-atc-text]');
    var priceEl = root.querySelector('[data-cz-price]');
    var atcLabel = (atc && atc.getAttribute('data-atc-label')) || 'Add to cart';
    var cartAdd = root.getAttribute('data-cart-add') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';

    function selectedValues(){
      var vals = [];
      root.querySelectorAll('.cz-pdp__opt').forEach(function(opt){
        var i = parseInt(opt.getAttribute('data-cz-option'), 10);
        var checked = opt.querySelector('input[data-cz-value="' + i + '"]:checked');
        vals[i] = checked ? checked.value : null;
      });
      return vals;
    }
    function findVariant(vals){
      return variants.find(function(v){
        return v.options.every(function(o, idx){ return o === vals[idx]; });
      });
    }
    // A value at option i is offered only if some variant matches the choices made
    // in EARLIER options (cascading left-to-right, e.g. Fabric -> Color).
    function existsGivenPrior(i, value){
      var vals = selectedValues();
      return variants.some(function(v){
        if(v.options[i] !== value) return false;
        for(var idx = 0; idx < i; idx++){
          if(vals[idx] != null && v.options[idx] !== vals[idx]) return false;
        }
        return true;
      });
    }
    // Available if SOME variant matching the currently-chosen options (ignoring not-yet-chosen
    // ones) plus this value is in stock. Partial selections therefore don't mark things sold-out.
    function comboAvailable(i, value){
      var vals = selectedValues().slice();
      vals[i] = value;
      return variants.some(function(vv){
        for(var idx = 0; idx < vals.length; idx++){ if(vals[idx] != null && vv.options[idx] !== vals[idx]) return false; }
        return vv.available;
      });
    }
    // When an earlier option changes, repair any now-invalid downstream selections.
    function resolveFrom(changedIndex) {
        root.querySelectorAll('.cz-pdp__opt').forEach(function(opt) {
            if (opt.dataset.czLinked) return;
            var j = parseInt(opt.getAttribute('data-cz-option'), 10);
        if(j <= changedIndex) return;
        var current = opt.querySelector('input[data-cz-value]:checked');
        if(current && existsGivenPrior(j, current.value)) return;
        var inputs = opt.querySelectorAll('input[data-cz-value]');
        for(var k = 0; k < inputs.length; k++){
          if(existsGivenPrior(j, inputs[k].value)){ inputs[k].checked = true; break; }
        }
      });
    }
    // When a later option is picked (e.g. a Color swatch) with earlier options still unset,
    // auto-select those earlier options (e.g. its Fabric) from a matching variant, so one
    // click completes the selection. Only fills options BEFORE the one just changed.
    function autoFillUpstream(changedIndex){
      var vals = selectedValues();
      var match = variants.filter(function(vv){
        for(var idx = 0; idx < vals.length; idx++){ if(vals[idx] != null && vv.options[idx] !== vals[idx]) return false; }
        return true;
      });
      if(!match.length) return;
      var chosen = match.filter(function(v){ return v.available; })[0] || match[0];
      root.querySelectorAll('.cz-pdp__opt').forEach(function(opt) {
          if (opt.dataset.czLinked) return;
          var i = parseInt(opt.getAttribute('data-cz-option'), 10);
          if (i >= changedIndex)
              return;
          // only earlier options
        if(opt.querySelector('input[data-cz-value]:checked')) return;   // already chosen
        var want = chosen.options[i];
        var inputs = opt.querySelectorAll('input[data-cz-value]');
        for(var k = 0; k < inputs.length; k++){ if(inputs[k].value === want){ inputs[k].checked = true; break; } }
      });
    }
    // Hide values that don't pair with the earlier choices; grey out sold-out combos.
    function applyVisibility() {
        root.querySelectorAll('.cz-pdp__opt').forEach(function(opt) {
            if (opt.dataset.czLinked) return;
            var i = parseInt(opt.getAttribute('data-cz-option'), 10);
        opt.querySelectorAll('.cz-pdp__swatch').forEach(function(sw){
          var input = sw.querySelector('input');
          var exists = existsGivenPrior(i, input.value);
          sw.classList.toggle('is-hidden', !exists);
          if(exists) sw.classList.toggle('is-unavailable', !comboAvailable(i, input.value));
        });
      });
    }
    function renderPrice(v){
      if(!v || !prices[v.id] || !priceEl) return;
      var p = prices[v.id];
      var html = '<span class="cz-current">' + p.price + '</span>';
      if(p.on_sale && p.compare){ html += '<span class="cz-compare">' + p.compare + '</span>'; }
      if(p.unit){ html += '<span class="cz-unit">' + p.unit + ' / unit</span>'; }
      priceEl.innerHTML = html;
    }
    // ---- Gallery: main image + 2-column grid below; each variant photo is hidden until that variant is selected ----
    var czTrack = root.querySelector('[data-cz-track]');
    var czSlides = czTrack ? Array.prototype.slice.call(czTrack.querySelectorAll('.cz-pdp__slide')) : [];
    var czGrid = Array.prototype.slice.call(root.querySelectorAll('[data-cz-grid]'));
    var czDots = Array.prototype.slice.call(root.querySelectorAll('[data-cz-dot]'));
    var czCounter = root.querySelector('[data-cz-counter]');
    var czPrev = root.querySelector('[data-cz-prev]');
    var czNext = root.querySelector('[data-cz-next]');
    // A "variant image" is a photo linked to a variant (variant.featured_media). These
    // stay hidden until their variant is selected; every other (non-variant) photo stays
    // in the carousel at all times. This relies only on Shopify's native variant->image
    // link, so it needs no per-image color detection and scales as variants are added.
    var czVariantMedia = {};
    variants.forEach(function(v){ if(v.media && String(v.media) !== '0'){ czVariantMedia[String(v.media)] = true; } });
    // The carousel = the first N NON-variant images (the general / hero / lifestyle shots).
    // Anything beyond N is hidden, so image-heavy products stay tidy. N is set per section
    // (data-cz-carousel-max, 4-8). Which N you get is just the product's media order in
    // Shopify — reorder there to choose. Variant images are separate and each shows only
    // when its variant is selected. No alt text, no filename parsing — purely the variant link.
    var czCarouselMax = parseInt(root.getAttribute('data-cz-carousel-max'), 10);
    if(isNaN(czCarouselMax) || czCarouselMax < 1) czCarouselMax = 8;
    var czCarousel = {}, czSeen = 0;
    czSlides.forEach(function(s){
      var mid = String(s.getAttribute('data-media-id'));
      if(!czVariantMedia[mid] && czSeen < czCarouselMax){ czCarousel[mid] = true; czSeen++; }
    });
    // Fallback: if the product has NO general (non-variant) photos (every image is a
    // variant image, e.g. cover / color-only products), there's nothing to show until a
    // variant is picked. On a product that requires a selection that renders the gallery
    // blank on load. Treat the first N images as the baseline carousel so all colors stay
    // browsable, and still deep-focus the one whose variant is selected.
    var czAllVariant = (czSeen === 0);
    if(czAllVariant){
      czSlides.forEach(function(s){
        var mid = String(s.getAttribute('data-media-id'));
        if(czSeen < czCarouselMax){ czCarousel[mid] = true; czSeen++; }
      });
    }
    function visibleSlides(){ return czSlides.filter(function(s){ return s.style.display !== 'none'; }); }
    function currentSlide(){
      if(!czTrack) return null;
      var best = null, bestD = Infinity;
      visibleSlides().forEach(function(s){
        var d = Math.abs(s.offsetLeft - czTrack.scrollLeft);
        if(d < bestD){ bestD = d; best = s; }
      });
      return best;
    }
    function goToSlide(s, instant){ if(czTrack && s && s.style.display !== 'none') czTrack.scrollTo({ left: s.offsetLeft, behavior: instant ? 'auto' : 'smooth' }); }
    function galleryStep(dir){
      var vis = visibleSlides(), cur = currentSlide();
      var pos = cur ? vis.indexOf(cur) : 0;
      goToSlide(vis[Math.max(0, Math.min(pos + dir, vis.length - 1))]);
    }
    function gallerySync(){
      var cur = currentSlide(); if(!cur) return;
      var absI = czSlides.indexOf(cur), vis = visibleSlides(), vpos = vis.indexOf(cur);
      czGrid.forEach(function(t, k){ t.classList.toggle('is-active', k === absI); });
      czDots.forEach(function(d, k){ d.classList.toggle('is-active', k === absI); });
      if(czCounter) czCounter.textContent = (vpos + 1) + ' / ' + vis.length;
      if(czPrev) czPrev.disabled = (vpos <= 0);
      if(czNext) czNext.disabled = (vpos >= vis.length - 1);
    }
    function updateGallery(mediaId){
      if(!mediaId) return;
      for(var i = 0; i < czSlides.length; i++){
        if(String(czSlides[i].getAttribute('data-media-id')) === String(mediaId)){ goToSlide(czSlides[i]); return; }
      }
    }
    // Show every non-variant photo always; show a variant-linked photo only when its
    // variant is the selected one. (selMedia = the selected variant's featured_media id.)
    function applyGalleryFilter(v){
      var selMedia = (v && v.media) ? String(v.media) : '';
      czSlides.forEach(function(s, i){
        var mid = String(s.getAttribute('data-media-id'));
        var show;
        if(czVariantMedia[mid] && !czAllVariant){ show = (mid === selMedia); }  // variant image -> only when its variant is selected
        else { show = !!czCarousel[mid] || (czAllVariant && mid === selMedia); }  // general image -> only the first N (the carousel); on all-variant products the selected variant's photo also shows, even past N
        s.style.display = show ? '' : 'none';
        if(czGrid[i]) czGrid[i].style.display = show ? '' : 'none';
        if(czDots[i]) czDots[i].style.display = show ? '' : 'none';
      });
    }
    // Anchor the main image to the selected variant's own photo (if it has one).
    function focusColorImage(v){
      var selMedia = (v && v.media) ? String(v.media) : '';
      if(selMedia){
        for(var i = 0; i < czSlides.length; i++){
          var s = czSlides[i];
          if(s.style.display !== 'none' && String(s.getAttribute('data-media-id')) === selMedia){ goToSlide(s, true); return; }
        }
      }
      var vis = visibleSlides(); if(vis[0]) goToSlide(vis[0], true);
    }
    var czOpts = Array.prototype.slice.call(root.querySelectorAll('.cz-pdp__opt'));
    var czDynamic = root.querySelector('.cz-pdp__dynamic');
    var czTerms = root.querySelector('[data-cz-terms]');
    var selectLabel = (atc && atc.getAttribute('data-select-label')) || 'Select options';
    function leadToFirstCarousel(){
      for(var li = 0; li < czSlides.length; li++){
        if(czSlides[li].style.display !== 'none' && czCarousel[String(czSlides[li].getAttribute('data-media-id'))]){ goToSlide(czSlides[li], true); return; }
      }
    }
    function refresh(mediaFromVariant){
      var vals = selectedValues();
      czOpts.forEach(function(opt){
        var i = parseInt(opt.getAttribute('data-cz-option'), 10);
        var lbl = opt.querySelector('[data-cz-selected="' + i + '"]');
        if(lbl) lbl.textContent = vals[i] || '';
      });
      root.querySelectorAll('.cz-pdp__swatch').forEach(function(sw){
        var input = sw.querySelector('input');
        sw.classList.toggle('is-selected', input && input.checked);
      });
      czOpts.forEach(function(opt){ opt.classList.toggle('is-chosen', !!opt.querySelector('input[data-cz-value]:checked')); });
      // No option selectors -> single-variant product (auto-selected); else a full match of chosen values.
      var v = czOpts.length ? findVariant(vals) : (variants[0] || null);
      var allChosen = true;
      czOpts.forEach(function(opt){ if(!opt.querySelector('input[data-cz-value]:checked')) allChosen = false; });

      applyGalleryFilter(v);                                    // v null -> only the carousel shows (no variant photo)
      if(mediaFromVariant && v){ focusColorImage(v); } else { leadToFirstCarousel(); }
      gallerySync();

      if(idInput) idInput.value = v ? v.id : '';
      if(v) renderPrice(v);

      var buyable = !!(v && v.available);
      if(czDynamic) czDynamic.style.display = buyable ? '' : 'none';   // hide Shop Pay until a full variant is chosen
      if(czTerms){                                                     // installments preview: mirror Shop Pay visibility + re-price live
        czTerms.style.display = buyable ? '' : 'none';
        var terms = czTerms.querySelector('shopify-payment-terms');
        if(terms && v){ terms.setAttribute('variant-id', v.id); }
      }
      if(atc) atc.disabled = !buyable;
      if(atcText) atcText.textContent = buyable ? atcLabel : (v ? 'Sold out' : (allChosen ? 'Unavailable' : selectLabel));
    }

    root.querySelectorAll('input[data-cz-value]').forEach(function(input){
      input.addEventListener('change', function(){
        var idx = parseInt(input.getAttribute('data-cz-value'), 10);
        autoFillUpstream(idx);
        resolveFrom(idx);
        applyVisibility();
        refresh(true);
      });
    });
    root.querySelectorAll('[data-cz-qty]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var input = root.querySelector('[data-cz-qty-input]');
        if(!input) return;
        var val = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-cz-qty'), 10);
        if(val < 1) val = 1;
        input.value = val;
      });
    });
    // ---- Add-ons (snippets/cozey-addons.liquid) ----
    // Ticked add-on rows ride along in the SAME /cart/add.js request as the main product.
    function czAddonLines(){
      var out = [];
      var box = root.querySelector('[data-cz-addons]');
      var forTitle = box ? (box.getAttribute('data-cz-addon-for') || '') : '';
      // The parent product's id, so the checkout discount function can tell a widget add-on from the
      // same product added any other way, and check the parent is still in the cart. Titles change; ids don't.
      var forId = box ? (box.getAttribute('data-cz-addon-parent') || '') : '';
      root.querySelectorAll('[data-cz-addon-row][data-cz-addon-on="1"]').forEach(function(row){
        var id = parseInt(row.getAttribute('data-cz-addon-variant'), 10);
        var qty = parseInt(row.getAttribute('data-cz-addon-qty'), 10);
        if(!id) return;
        var type = row.getAttribute('data-cz-addon-type') || '';
        var line = { id: id, quantity: qty > 0 ? qty : 1 };
        if(forTitle || forId || type){
          line.properties = {};
          if(forTitle) line.properties._addon_for = forTitle;
          if(forId) line.properties._addon_parent = forId;
          if(type) line.properties._addon_type = type;
        }
        out.push(line);
      });
      return out;
    }
    // JSON cart body: main line (id, quantity, any properties[...] / selling_plan on the form) + add-on lines.
    function czAddonBody(fd, lines){
      var main = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      var props = null;
      fd.forEach(function(val, key){
        var m = /^properties\[(.+)\]$/.exec(key);
        if(m){ props = props || {}; props[m[1]] = val; }
        else if(key === 'selling_plan' && val){ main.selling_plan = val; }
      });
      if(props) main.properties = props;
      return { items: [main].concat(lines), sections: 'ajax-cart-drawer' };
    }
    if(form && atc){
      form.addEventListener('submit', function(e){
        if(atc.disabled){ e.preventDefault(); return; }
        e.preventDefault();
        atc.disabled = true;
        var prev = atcText ? atcText.textContent : '';
        if(atcText) atcText.textContent = 'Adding…';
        var czFd = new FormData(form);
        czFd.append('sections', 'ajax-cart-drawer');
        // Add-ons: nothing ticked -> czAddons is empty and the request is the original FormData post.
        var czAddons = czAddonLines();
        var czAdded = false;
        var czReq = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: czFd };
        if(czAddons.length){
          czReq = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(czAddonBody(czFd, czAddons)) };
        }
        fetch(cartAdd + '.js', czReq)
          .then(function(r){
            if(r.ok) return r.json();
            if(!czAddons.length) throw new Error('add failed');
            return r.json().catch(function(){ return {}; }).then(function(j){
              var err = new Error((j && typeof j.description === 'string') ? j.description : '');
              err.czAddons = true;
              throw err;
            });
          })
          .then(function(res){
            if(czAddons.length){
              czAdded = true;
              root.dispatchEvent(new CustomEvent('cz:addons:added', { bubbles: true, detail: { lines: czAddons } }));
            }
            var drawer = document.querySelector('#ajax-cart-drawer');
            var drawerBody = document.querySelector('[data-cart-drwaer-body]');
            if(res && res.sections && res.sections['ajax-cart-drawer'] && drawerBody){
              var parsed = new DOMParser().parseFromString(res.sections['ajax-cart-drawer'], 'text/html').querySelector('.shopify-section');
              if(parsed){ drawerBody.innerHTML = parsed.innerHTML; }
            }
            if(!drawer){ window.location.href = cartUrl; return; }
            fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
              .then(function(r){ return r.json(); })
              .then(function(c){
                document.querySelectorAll('[data-header-cart-count]').forEach(function(el){
                  el.textContent = (c.item_count > 0 && c.item_count < 100) ? c.item_count : '';
                  el.classList.toggle('hidden', c.item_count < 1);
                });
                if(typeof cartCountUpdate === 'function'){ try { cartCountUpdate(c.item_count); } catch(err){} }
                if(typeof getQuantityElement === 'function'){ try { getQuantityElement(drawerBody); } catch(err){} }
                if(typeof getCartItemRemoveElements === 'function'){ try { getCartItemRemoveElements(drawerBody); } catch(err){} }
                if(typeof cartGiftWrapElement === 'function'){ try { cartGiftWrapElement(drawerBody); } catch(err){} }
              })
              .catch(function(){});
            drawer.style.display = 'flex';
            setTimeout(function(){ drawer.classList.add('sidebar-visible'); }, 20);
            document.body.classList.add('no-scroll');
            atc.disabled = false;
            if(atcText) atcText.textContent = prev;
          })
          .catch(function(err){
            atc.disabled = false; if(atcText) atcText.textContent = prev;
            if(czAddons.length){
              // Never fall back to a native form post here: it would add the main product without its add-ons.
              if(!czAdded) root.dispatchEvent(new CustomEvent('cz:addons:error', { bubbles: true, detail: { message: (err && err.message) || '' } }));
              return;
            }
            form.submit();
          });
      });
    }
    if(czTrack){
      var czRaf = null;
      czTrack.addEventListener('scroll', function(){
        if(czRaf) return;
        czRaf = requestAnimationFrame(function(){ czRaf = null; gallerySync(); });
      });
    }
    czGrid.forEach(function(t, k){ t.addEventListener('click', function(){ goToSlide(czSlides[k]); }); });
    czDots.forEach(function(d, k){ d.addEventListener('click', function(){ goToSlide(czSlides[k]); }); });
    if(czPrev) czPrev.addEventListener('click', function(){ galleryStep(-1); });
    if(czNext) czNext.addEventListener('click', function(){ galleryStep(1); });
    gallerySync();

    applyVisibility();
    refresh(false);
  }

  function initAll(scope){ (scope || document).querySelectorAll('.cz-pdp').forEach(initPDP); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  else { initAll(); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

/* Deep link: honor ?variant=<id> in the URL (e.g. from the Fur/Outlet collection cards) by
   pre-selecting that variant's options exactly as if the shopper clicked the swatches.
   Runs after initPDP has attached its change handlers; no-op when the param is absent. */
(function(){
  function czPreselectFromUrl(){
    try{
      var id = new URLSearchParams(window.location.search).get('variant');
      if(!id) return;
      document.querySelectorAll('.cz-pdp').forEach(function(root){
        var vEl = root.querySelector('[data-cz-variants]');
        if(!vEl) return;
        var variants = [];
        try{ variants = JSON.parse(vEl.textContent); }catch(e){}
        var v = variants.filter(function(x){ return String(x.id) === String(id); })[0];
        if(!v) return;
        var last = null;
        root.querySelectorAll('.cz-pdp__opt').forEach(function(opt){
          var i = parseInt(opt.getAttribute('data-cz-option'), 10);
          var want = v.options[i];
          opt.querySelectorAll('input[data-cz-value]').forEach(function(inp){
            if(inp.value === want){ inp.checked = true; last = inp; }
          });
        });
        if(last){ last.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }catch(e){}
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', czPreselectFromUrl); }
  else { czPreselectFromUrl(); }
})();